import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

let cachedLogoUrl = null;
const subscribers = new Set();

const fetchLogo = async () => {
  try {
    const { data } = await api.get("/settings/branding");
    cachedLogoUrl = data?.logo_url || "/logo.png";
  } catch {
    cachedLogoUrl = "/logo.png";
  }
  subscribers.forEach((cb) => cb(cachedLogoUrl));
};

export const BrandLogo = ({ className = "w-5 h-5", alt = "Safe Harbor Veterans" }) => {
  const [url, setUrl] = useState(cachedLogoUrl || "/logo.png");
  useEffect(() => {
    if (!cachedLogoUrl) fetchLogo();
    subscribers.add(setUrl);
    return () => { subscribers.delete(setUrl); };
  }, []);
  return <img src={url} alt={alt} className={className} onError={(e) => { e.currentTarget.src = "/logo.png"; }} />;
};
